import { useState, useCallback, useRef } from 'react';
import { createPortal } from 'react-dom';

const TOAST_ORDER = { error: 0, info: 1, success: 2 };

function sortToasts(list) {
  return [...list].sort((a, b) => {
    const diff = (TOAST_ORDER[a.type] ?? 1) - (TOAST_ORDER[b.type] ?? 1);
    if (diff !== 0) return diff;
    return b.id - a.id;
  });
}

export function useToast() {
  const [toasts, setToasts] = useState([]);
  const idRef = useRef(0);

  const showToast = useCallback((message, type = 'info') => {
    const id = ++idRef.current;
    setToasts((prev) => sortToasts([{ id, message, type }, ...prev]));
    setTimeout(() => {
      setToasts((prev) => prev.filter((t) => t.id !== id));
    }, type === 'error' ? 6000 : 4200);
  }, []);

  const ToastContainer = () => {
    if (typeof document === 'undefined') return null;
    return createPortal(
      <div className="toast-container" aria-live="assertive" aria-relevant="additions">
        {toasts.map((t) => (
          <div
            key={t.id}
            className={`toast toast--${t.type} toast-enter`}
            role={t.type === 'error' ? 'alert' : 'status'}
          >
            {t.message}
          </div>
        ))}
      </div>,
      document.body
    );
  };

  return { showToast, ToastContainer };
}
